import fetch from "./utils/enhancedFetch";
import { getProxycadorHost } from "environment";

export const fetchMySuspensionStatus = (): Promise<boolean> =>
  fetch(`${getProxycadorHost()}/proxycador/api/public/v1/suspend/me`).then(
    (resp) => resp.json()
  );
